import { GlButton, GlButtonGroup, GlDisclosureDropdownItem } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'CodeDropdownDownloadItems',
    components: {
        GlButton,
        GlButtonGroup,
        GlDisclosureDropdownItem
    },
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    emits: [
        'close-dropdown'
    ]
};
